import angular from 'angular';
import template from './searchbox.html';
import './searchbox.scss';
/**
 * Handles the search callback and the form binding.
 */
export class SearchboxController {
  /**
   * @ignore
   */
  constructor() {
    /**
     * The binding for the search field value on the form.
     * @type {string}
     */
    this.text = '';
  }
  /**
   * This lifecycle method is used to set the default values of the optional bindings.
   */
  $postLink() {
    if (angular.isUndefined(this.showButton)) {
      this.showButton = true;
    }
    if (angular.isUndefined(this.placeholder)) {
      this.placeholder = 'Search';
    }
  }
  /**
   * Trigger the `onSearch` callback with the current value of the field.
   */
  search() {
    this.onSearch({ text: this.text });
  }
}
/**
 * Shows a simple search box.
 * @ngesdoc component
 * @ngname seachbox
 * @ngcontroller {@link SearchboxController}
 * @ngmodule common
 * @ngbinding {string}   id                     An identifier for the HTML ID property of the field.
 * @ngbinding {Function} onSearch               The callback the component calls when the user
 *                                              writes something on the field. It will receive a
 *                                              `text` parameter.
 * @ngbinding {boolean}  [disableSearch=false]  Whether or not the field should be disabled.
 * @ngbinding {number}   [debounce=500]         A debounce option for the callback. In milliseconds.
 * @ngbinding {string}   [placeholder='Search'] The input placeholder
 * @ngbinding {boolean}  [showButton=true]      Whether or not to show the icon.
 */
export default {
  controller: SearchboxController,
  template,
  bindings: {
    id: '@',
    onSearch: '&',
    disableSearch: '<',
    debounce: '@',
    placeholder: '@',
    showButton: '<',
  },
};
